import { RegularButton } from 'fronton-react';
import { projectsSlice } from 'app-entities/projects/projects-slice';
import { useAppSelector, useAppDispatch } from 'common/hooks';
import { GAClickButton } from 'common/analytics/ga';
import { useGAElementBlock } from 'common/analytics/use-ga-element-block';
import { dataFromParentMicrofrontSlice } from 'store/data-from-parent-microfront-slice';
import { loadMoreContainer, loadMoreContainer__button } from './styles';

export const LoadMoreButton = () => {
  const elementBlock = useGAElementBlock();
  const dispatch = useAppDispatch();
  const title = useAppSelector(dataFromParentMicrofrontSlice.selectors.selectGalleryTitle);
  const isLoading = useAppSelector(projectsSlice.selectors.selectIsLoading);
  const lastSearchParams = useAppSelector(projectsSlice.selectors.selectLastSearchParams);
  const nextSearchPage = useAppSelector(projectsSlice.selectors.selectNextSearchPage);
  const isNextPageAvailable = useAppSelector(projectsSlice.selectors.selectIsNextPageAvailable);
  const analyticsName = useAppSelector(dataFromParentMicrofrontSlice.selectors.selectAnalyticsName);

  const handleLoad = () => {
    dispatch(projectsSlice.actions.requestProjects({ ...lastSearchParams, page: nextSearchPage }));

    GAClickButton({
      elementName: title,
      elementText: 'Показать ещё',
      elementBlock: analyticsName || elementBlock,
    });
  };

  if (isNextPageAvailable) {
    return (
      <div className={loadMoreContainer}>
        <RegularButton
          data-testid="load-more-button"
          onClick={handleLoad}
          className={loadMoreContainer__button}
          size="l"
          rounded
          variant="outline"
          loading={isLoading}>
          Показать ещё
        </RegularButton>
      </div>
    );
  }

  return null;
};
